import revive_payload_client_4sVQNw7RlN from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import theme_init_7vFcvaOCOT from "E:/W2/VM/VM.Cms/plugins/theme-init.ts";
import payload_client_yVLowv6hDl from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "E:/W2/VM/VM.Cms/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "E:/W2/VM/VM.Cms/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "E:/W2/VM/VM.Cms/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_vue3_YdLad5Mpq3 from "E:/W2/VM/VM.Cms/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "E:/W2/VM/VM.Cms/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "E:/W2/VM/VM.Cms/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import directives_8CcCirWtnE from "E:/W2/VM/VM.Cms/plugins/directives.ts";
import helpers_mgWmzbOuLB from "E:/W2/VM/VM.Cms/plugins/helpers.ts";
import notifications_client_mBACvv4vx7 from "E:/W2/VM/VM.Cms/plugins/notifications.client.ts";
import swiper_eteSCvuYkd from "E:/W2/VM/VM.Cms/plugins/swiper.ts";
import vue3_toastify_OGYNDsiW9E from "E:/W2/VM/VM.Cms/plugins/vue3-toastify.ts";
import ssg_detect_3fHkBxLtv0 from "E:/W2/VM/VM.Cms/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  theme_init_7vFcvaOCOT,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  directives_8CcCirWtnE,
  helpers_mgWmzbOuLB,
  notifications_client_mBACvv4vx7,
  swiper_eteSCvuYkd,
  vue3_toastify_OGYNDsiW9E,
  ssg_detect_3fHkBxLtv0
]